export default "__VITE_ASSET__MJvvlT_O__"